// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"469":"f94ff16112b2da75","631":"a455b1bbf47627ea","905":"0863604c5c57b09d","931":"48740a4415769658"}[chunkId] + ".js";
};